module.exports = __webpack_public_path__ + "img/external-link.fae8253b.svg";